import { Skeleton, Card } from 'antd';

export function LoadingSkeleton({ rows = 6 }: { rows?: number }) {
  return (
    <Card>
      <Skeleton active paragraph={{ rows }} />
    </Card>
  );
}
